import { TvvDienst } from "@/entities/dossier-overzicht";
import { TvvStatus } from "@/features/dossier-balk/components/uitgezette-diensten/icons/tvv-status.tsx";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components";

type TvvStatusEnTooltipProps = {
    dienst: TvvDienst;
};

export function TvvStatusEnTooltip({ dienst }: TvvStatusEnTooltipProps) {
    const labels = [
        { label: "aangevraagd", count: dienst.countByStatus?.Aangevraagd },
        { label: "actief", count: dienst.countByStatus?.Gedeeltelijk },
        { label: "volledig", count: dienst.countByStatus?.Volledig },
        { label: "stop aangevraagd", count: dienst.countByStatus?.StopAangevraagd },
        { label: "gestopt", count: dienst.countByStatus?.Gestopt },
    ];

    return (
        <Tooltip key={dienst.type}>
            <TooltipTrigger data-testid="tvv-status">
                <TvvStatus variant={dienst.variant} />
            </TooltipTrigger>
            <TooltipContent className="max-w-full">
                {labels
                    .filter(({ count }) => count && count > 0)
                    .map(({ label, count }) => (
                        <p key={label}>
                            {count} route{count === 1 ? "" : "s"} {label}
                        </p>
                    ))}
            </TooltipContent>
        </Tooltip>
    );
}
